import React, { useEffect } from 'react';
import ImageGallery from 'react-image-gallery';

const HackathonExperienceSlide = ({ data }) => {
    useEffect(() => {
        console.log(data);
    }, [data]);
    return (
        <div className='mx-4'>
            {data && data.hackathonExp && (
                <>
                    <div className='backdrop-blur bg-white/20 w-3/4 md:max-w-5xl  mx-auto my-4 px-2 py-2 h-auto'>
                        <h1 className='text-center p-2 font-bold text-3xl my-2'>
                            Hackathon Experience
                        </h1>
                        <div className='mx-auto max-w-3xl'>
                            <ImageGallery items={data.hackathonExp} />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default HackathonExperienceSlide;
